export const deliveryOptionsQuoteIdentifier = 'DeliveryOptionQuoteIdentifier';
export const shipperHqMarketplaceOrderId = 'ShipperHQMarketplaceOrderId';
export const ThirdPartyDeliveryOptionQuoteIdentifier = 'ThirdPartyQuoteIdentifier';
